// Colors that we are using on SP but are not part of our UI library.
export const selectedColor = '#ACB9FD'
